import React, { useMemo } from "react";
import { useTheme } from "../../../../theme/utils/useTheme";
import { DatePickerYearSelectorStyled } from "../styled/DatePickerYearSelectorStyled";
export const DatePickerYearSelector = _ref => {
  let {
    locale,
    maxDate,
    minDate,
    onChange,
    selectedYear
  } = _ref;
  const {
    key
  } = useTheme();
  const themeMode = key;
  const userProvidedMinYear = minDate ? new Date(minDate.year, minDate.month, minDate.day).getFullYear() : null;
  const userProvidedMaxYear = maxDate ? new Date(maxDate.year, maxDate.month, maxDate.day).getFullYear() : null;
  const allYears = useMemo(() => getYearOptions(selectedYear, userProvidedMinYear, userProvidedMaxYear), [selectedYear, userProvidedMinYear, userProvidedMaxYear]);
  return /*#__PURE__*/React.createElement(DatePickerYearSelectorStyled, {
    options: allYears,
    onChange: value => {
      if (value === undefined || value === null || value.year === selectedYear) {
        // This won't really happen since this select isn't clearable.
        return;
      }
      onChange(value.year);
    },
    selectedOption: allYears.find(option => option.year === selectedYear) || null,
    getOptionKey: option => option.year,
    optionToString: option => option?.year.toString() || "",
    locale: locale,
    isClearable: false,
    themeMode: themeMode
  });
};
const DEFAULT_MIN_YEARS = 15;
const DEFAULT_MAX_YEARS = 15;
const getYearOptions = (selectedYear, providedStart, providedEnd) => {
  const start = providedStart ?? selectedYear - DEFAULT_MIN_YEARS;
  const end = providedEnd ?? selectedYear + DEFAULT_MAX_YEARS;
  return Array.from({
    length: end - start + 1
  }).map((_, index) => {
    const year = start + index;
    return {
      year
    };
  });
};
//# sourceMappingURL=DatePickerYearSelector.js.map